import React from 'react'
import {useTranslation} from 'react-i18next';
import "./LongLoader.scss"

const video = require('../assets/loader.mp4');

export const LongLoader = () => {
    const {t} = useTranslation();

    return (
        <div className="longLoader">
            <h2>{t("longLoader_dontReload")}</h2>
            <video width="100%" autoPlay loop muted>
                <source src={video} type="video/mp4"/>
            </video>
        </div>
    )
}
